var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"erro-versao"},[_c('h2',[_vm._v("Ops!")]),_c('p',[_vm._v(_vm._s(_vm.errText))])])}
var staticRenderFns = []

export { render, staticRenderFns }